export default __webpack_public_path__ + "static/media/597.032d2286.png";